<template>
  <div class="mini-cart-dropdown">
    <base-inline-loader v-if="$props.loading"/>
    <div class="mini-cart-header">
      {{ $t('miniCart.myCart') }} ({{ $props.cartData.totalItems || 0 }})
      <span class="icon-close" @click="closeMiniCart"/>
    </div>
    <div class="mini-cart-body" :style="calcHeight ? `height: ${calcHeight}px` : ''">
      <mini-cart-items v-if="Object.keys($props.cartData).length && !!$props.cartData.entries.length"
                       :cartData="$props.cartData"/>
      <mini-cart-empty v-else/>
    </div>
    <mini-cart-footer :cartData="$props.cartData" :cartIsEmpty="!!Object.keys($props.cartData).length && !!$props.cartData.entries.length"/>
  </div>
</template>

<script>
import MiniCartItems from '@/components/mini-cart/mini-cart-items'
import MiniCartEmpty from '@/components/mini-cart/mini-cart-empty'
import MiniCartFooter from '@/components/mini-cart/mini-cart-footer'
import BaseInlineLoader from '@/components/base/base-inline-loader'
import mediaQuery from '@/utils/mediaQuery'
import debounce from '@/utils/debounce'

export default {
  name: 'mini-cart-dropdown',
  components: { MiniCartItems, MiniCartEmpty, MiniCartFooter, BaseInlineLoader },
  props: {
    cartData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      calcHeight: !mediaQuery(768) ? innerHeight - 140 : null
    }
  },

  created () {
    window.addEventListener('resize', () => debounce(() => {
      this.calcHeight = !mediaQuery(768) ? innerHeight - 140 : null
    }, 50))
  },

  methods: {
    closeMiniCart () {
      this.$emit('close-mini-cart')
    }
  }
}
</script>

<style lang="scss" scoped>
.mini-cart-dropdown {
  position: fixed;
  top: 0;
  left: 0;
  padding-top: 5.9rem;
  width: 100%;
  min-height: 100vh;
  background: $white;
  z-index: 2;

  @media (map_get($breakpoints, sm)) {
    position: absolute;
    right: -4.7rem;
    top: 5rem;
    left: auto;
    box-shadow: 0 .3rem .6rem rgba(0, 0, 0, .16);
    padding-top: 0;
    min-width: 45rem;
    min-height: 23.6rem;
  }

  &:before {
    @media (map_get($breakpoints, sm)) {
      content: "";
      position: absolute;
      right: 5rem;
      top: -1.1rem;
      width: 0;
      height: 0;
      border-left: 1.2rem solid transparent;
      border-right: 1.2rem solid transparent;
      border-bottom: 1.2rem solid $orange;
    }
  }

  .inline-loader {
    position: absolute;
    top: 0;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    z-index: 1;
  }
}

.mini-cart-header {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.4rem 2rem;
  width: 100%;
  background: linear-gradient(90deg, $dark-red, #cf1432 17%, $mtel-red 51%, $warning);
  color: $white;
  font-size: 2rem;

  @media (map_get($breakpoints, sm)) {
    position: static;
  }

  .icon-close {
    font-size: 1.6rem;
    cursor: pointer;

    @media (map_get($breakpoints, sm)) {
      display: none;
    }
  }
}
</style>
